module.exports = __webpack_public_path__ + "08bdd23bcfb6f292e304706d039959a1.svg";